/* No globals, tracking, network, cart interception, or changes outside the root. */
(() => {
  'use strict';
  const roots = document.querySelectorAll('[data-nt-hhv3-root]');
  if (!roots.length) return;
  const normalize = value => String(value || '').normalize('NFKC').toLocaleLowerCase().trim();
  roots.forEach(root => {
    if (root.dataset.ntHhv3Ready === 'true') return;
    root.dataset.ntHhv3Ready = 'true';
    const search = root.querySelector('[data-hv-search-input]');
    const cards = Array.from(root.querySelectorAll('[data-hv-card]'));
    const count = root.querySelector('[data-hv-count]');
    const empty = root.querySelector('[data-hv-empty]');
    const reset = root.querySelector('[data-hv-reset]');
    const update = () => {
      const query = normalize(search ? search.value : '');
      let visible = 0;
      cards.forEach(card => {
        const match = !query || normalize(card.dataset.hvSearch).includes(query);
        card.hidden = !match;
        visible += match ? 1 : 0;
      });
      if (count) count.textContent = query
        ? `本頁找到 ${visible} 篇文章。此搜尋不包含其他分頁。`
        : `本頁 ${cards.length} 篇文章。也可從上方五個主題繼續閱讀。`;
      if (empty) empty.hidden = visible !== 0;
    };
    if (search) search.addEventListener('input', update);
    if (reset) reset.addEventListener('click', () => {
      if (search) { search.value = ''; update(); search.focus(); }
    });
    root.querySelectorAll('[data-hv-media]').forEach(media => {
      const image = media.querySelector('img');
      const fallback = media.querySelector('[data-hv-fallback]');
      if (!image) return;
      const recover = () => {
        image.hidden = true;
        if (fallback) fallback.hidden = false;
      };
      image.addEventListener('error', recover, {once:true});
      if (image.complete && !image.naturalWidth) recover();
    });
    update();
  });
})();
